import "./App.css";
import { useState } from "react";
import Title from "./components/title/title";
function App() {
const [calc,setCalc]= useState("");
const [result,setResult]= useState("");

const ops = ['/','*','+','-','.'];

const updateCalc = value => {
    //  Condition so the operators dont get repeadted or dont appear before any digit
    if( ops.includes(value) && calc ==='' || 
    ops.includes(value) && ops.includes(calc.slice(-1)))
    {
        return;
    }
    setCalc(calc + value);
    

    //Condition to get the result or update it
    if(!ops.includes(value)){
      setResult(eval(calc + value).toString()); //so eval here will do the operation of adding the string inputs as integers and not strings(concatinate!),
    }
    
}
// creating a function for generating numbers from 1 to 9
const genNum = () => {
    const num = [];
    
    for (let i = 1; i < 10 ; i++){
        num.push(
            <button onClick={() => updateCalc(i.toString())} 
            key={i}>
            {i}
            </button>
        )
    }
    return num;
}

const calculate = () =>{
    setCalc(eval(calc).toString());
}
const deleteInput = () =>{
    if ( calc == ''){
        return;        
    }
    else{
        const value = calc.slice(0,-1);

        setCalc(value);
    }
}


  return (
    <>
    <Title/>
    <div className="App">
      <div className="calculator">
        <div className="display">
          { result ? <span>({result})</span> : ''} {/*if there is a value then we show it or else nothing */}
          { calc || "0"} {/*if calc has no value then it will show 0*/}
        </div>

        <div className="operators">
          <button onClick={() => updateCalc('/')}>/</button>
          <button onClick={() => updateCalc('*')}>*</button>
          <button onClick={() => updateCalc('+')}>+</button>
          <button onClick={() => updateCalc('-')}>-</button>

          <button onClick={deleteInput}>DEL</button>
        </div>

        <div className="num">
            { genNum() }
            <button onClick={() => updateCalc('0')}>0</button>
            <button onClick={() => updateCalc('.')}>.</button>

            <button onClick={calculate}>=</button>
        </div>
      </div>
    </div>
    </>
    
  );
}

export default App;
